import React, { useState } from "react";
import styles from "../../pages/OnBoarding/UserOnboarding.module.css";
import pass from "./LoginForm.module.css"   
import cogoToast from "cogo-toast-react-17-fix";
import API from "../../ApiConfig"
import { FORGOT_PASSWORD } from "../../Utils/constant";
import { Delay, EMAIL_CHECK } from "../../Utils/helper";
import BtnLoader from "../BtnLoader";
import SlideUpWrapper from "../Transitions/SlideUpWrapper";
import RightContent1 from "./login_right";
import Loader from "../Loader";
import { BUTTONS } from "../../Utils/Strings";
import { useNavigate } from "react-router-dom";
const ForgotPassword=()=>{
    
    const [email,setEmail]=useState('');
    const [loading,setLoading]=useState(false);
    const navigate=useNavigate()
    const getEmail=async (e)=>{
        e.preventDefault()
        if(email=="")
            cogoToast.error("Please enter email !!")
        else if (!EMAIL_CHECK(email)){
            cogoToast.error("Enter Valid Email")
        }
        else{
        setLoading(true)
        await Delay()
        API.get(FORGOT_PASSWORD+email)
        .then(res=>{
            setLoading(false)
            if(res.status==200)
                cogoToast.success("Email sent to "+email)
            })
            .catch(err=>{
                setLoading(false)
                cogoToast.error(err.response.data.detail)
            })
        }
    }
    return(
        <SlideUpWrapper direction="slide-left">

        <div className={styles.userOnboarding}>
            <Loader isOpen={loading}/>
            <form className={pass.leftContent}>
                <div className={styles.progressForm}>
                    <div className={styles.progressForm1}>
                        <div className={pass.form}>                            
                            <div className={styles.form1}>
                                <img src="/lock.svg" alt="lock.svg" className={pass.lock}/>
                                <div className={styles.headingHelperText}>
                                    <h3 className={pass.Resetheading}>Reset your password</h3>
                                    <div className={pass.supportingText}>
                                        <span className={pass.weMessagedA} style={{fontSize:"18px"}}>Forgot your password? Enter your registered email address, and we’ll send you a link to reset it.</span>                                
                                        <p className={styles.weMessagedASixDigitCodeT} style={{margin:"25px 0px", fontSize:"14px"}}> 
                                        <span className={pass.weMessagedA} style={{color:"#1c64f2"}}>If you’re an existing WorkAtTest user, reset your password using your WorkAtTest registered email. Your WorkAttest password won’t work here — please reset it before logging in.</span>
                                        </p>
                                        <p className={styles.weMessagedASixDigitCodeT} style={{fontSize:"14px"}}> 
                                        <span className={pass.weMessagedA}><button onClick={()=>navigate("/login")} style={{backgroundColor:"black", fontSize:"16px"}} className="btn btn-primary">Click here to login</button></span>
                                        </p>                              
                                        <div className={pass.inputdiv}>  
                                            <input type="text" className={pass.email} id="name" name="name" value={email} placeholder="Enter your email" onChange={e=>setEmail(e.target.value)}/>
                                        </div>
                                        {email.length>0 &&
                                        <button onClick={(e)=>getEmail(e)} className={pass.forgotBtn} style={{width:"100%"}}>{loading?<BtnLoader label={BUTTONS.SENDING}/>:"Get email"}</button>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={pass.copyright}>
                Copyright 2026 AuthBridge, All Rights Reserved.
            </div>
            </form>
      <RightContent1 />
        </div>
        </SlideUpWrapper>
    )

}
export default ForgotPassword;